import { VIEWER_SET_IS_AXIAL_VIEW_LOADED } from '../actions';

export default function setIsAxialViewLoaded(isLoaded) {
  return {
    type: VIEWER_SET_IS_AXIAL_VIEW_LOADED,
    isLoaded,
  };
}
